import React from "react";
import { Badge } from "./ui/badge";

const FORMAT_STYLES = {
  PDF: "bg-rose-100 text-rose-800 border-rose-300",
  Word: "bg-blue-100 text-blue-800 border-blue-300",
  Excel: "bg-emerald-100 text-emerald-800 border-emerald-300",
  Pantalla: "bg-amber-100 text-amber-800 border-amber-300",
};

const ENTREGABLES_MAP = {
  prevalidacion: [
    {
      nombre: "Reporte de prevalidación del Precontrato",
      formatos: ["Pantalla"],
      descripcion: "Resumen de necesidad, objeto preliminar, valor estimado y estado de información.",
    },
    {
      nombre: "Ficha inicial del Precontrato",
      formatos: ["Pantalla"],
      descripcion: "Datos base: entidad/cliente, necesidad, objeto tentativo, plazo, presupuesto, categoría, modalidad probable.",
    },
    {
      nombre: "Semáforo de completitud",
      formatos: ["Pantalla"],
      descripcion: "Verde/amarillo/rojo según calidad de la información suministrada.",
    },
    {
      nombre: "Checklist de información faltante",
      formatos: ["PDF", "Pantalla"],
      descripcion: "Qué falta para poder diagnosticar o documentar bien.",
    },
    {
      nombre: "Alertas iniciales",
      formatos: ["Pantalla"],
      descripcion: "Falta presupuesto, objeto ambiguo, modalidad dudosa, falta soporte técnico, riesgo alto.",
    },
    {
      nombre: "Recomendación para el siguiente paso",
      formatos: ["Pantalla"],
      descripcion: "Avanzar a Diagnóstico o Completar información antes de pagar.",
    },
    {
      nombre: "Normativas usadas",
      formatos: ["Pantalla"],
      descripcion: "Las normativas usadas para validar jurídicamente.",
    },
  ],
  diagnostico: [
    {
      nombre: "Informe de diagnóstico precontractual",
      formatos: ["PDF", "Word"],
      descripcion: "Resumen ejecutivo, necesidad, objeto preliminar, supuestos y nivel de completitud.",
    },
    {
      nombre: "Ruta o modalidad recomendada",
      formatos: ["PDF", "Pantalla"],
      descripcion: "Modalidad probable y alternativas, con advertencias.",
    },
    {
      nombre: "Matriz preliminar de riesgos",
      formatos: ["Excel", "PDF"],
      descripcion: "Riesgos iniciales, impacto, probabilidad, mitigación sugerida.",
    },
    {
      nombre: "Matriz de completitud documental",
      formatos: ["Excel", "Pantalla"],
      descripcion: "Qué información existe, qué falta y qué bloquea avanzar.",
    },
    {
      nombre: "Checklist de estructuración",
      formatos: ["PDF", "Pantalla"],
      descripcion: "Lista de documentos y anexos que deberían prepararse.",
    },
    {
      nombre: "Alertas jurídicas y operativas",
      formatos: ["PDF", "Pantalla"],
      descripcion: "Riesgos de objeto, cuantía, modalidad, requisitos, garantías, plazo, supervisión.",
    },
    {
      nombre: "Preguntas de aclaración",
      formatos: ["PDF", "Pantalla"],
      descripcion: "Preguntas que el cliente debe responder antes del Kit.",
    },
    {
      nombre: "Recomendación de upgrade",
      formatos: ["Pantalla"],
      descripcion: "Este caso sí/no está listo para Kit Documental.",
    },
  ],
  diagnostico_revisado: [
    {
      nombre: "Informe de diagnóstico precontractual",
      formatos: ["PDF", "Word"],
      descripcion: "Resumen ejecutivo, necesidad, objeto preliminar, supuestos y nivel de completitud.",
    },
    {
      nombre: "Ruta o modalidad recomendada",
      formatos: ["PDF", "Pantalla"],
      descripcion: "Modalidad probable y alternativas, con advertencias.",
    },
    {
      nombre: "Matriz preliminar de riesgos",
      formatos: ["Excel", "PDF"],
      descripcion: "Riesgos iniciales, impacto, probabilidad, mitigación sugerida.",
    },
    {
      nombre: "Matriz de completitud documental",
      formatos: ["Excel", "Pantalla"],
      descripcion: "Qué información existe, qué falta y qué bloquea avanzar.",
    },
    {
      nombre: "Checklist de estructuración",
      formatos: ["PDF", "Pantalla"],
      descripcion: "Lista de documentos y anexos que deberían prepararse.",
    },
    {
      nombre: "Alertas jurídicas y operativas",
      formatos: ["PDF", "Pantalla"],
      descripcion: "Riesgos de objeto, cuantía, modalidad, requisitos, garantías, plazo, supervisión.",
    },
    {
      nombre: "Preguntas de aclaración",
      formatos: ["PDF", "Pantalla"],
      descripcion: "Preguntas que el cliente debe responder antes del Kit.",
    },
    {
      nombre: "Recomendación de upgrade",
      formatos: ["Pantalla"],
      descripcion: "Este caso sí/no está listo para Kit Documental.",
    },
    {
      nombre: "Informe revisado por experto",
      formatos: ["PDF", "Word"],
      descripcion: "Ajustes y observaciones humanas sobre el diagnóstico.",
    },
    {
      nombre: "Hoja de observaciones",
      formatos: ["PDF", "Word"],
      descripcion: "Comentarios concretos: riesgos, supuestos, vacíos y recomendaciones.",
    },
    {
      nombre: "Checklist de revisión humana",
      formatos: ["PDF"],
      descripcion: "Evidencia de qué se revisó.",
    },
    {
      nombre: "Versión ajustada del diagnóstico",
      formatos: ["PDF", "Word"],
      descripcion: "Versión corregida o comentada.",
    },
  ],
  kit: [
    {
      nombre: "Estudios previos / documento base de planeación",
      formatos: ["Word"],
      descripcion: "Necesidad, objeto, alcance, obligaciones, plazo, forma de pago, supervisión, modalidad, valor, riesgos y garantías.",
    },
    {
      nombre: "Justificación de modalidad de selección",
      formatos: ["Word"],
      descripcion: "Fundamento y explicación de la ruta recomendada.",
    },
    {
      nombre: "Análisis del sector / mercado básico",
      formatos: ["Word", "Excel"],
      descripcion: "Fuentes, comparables, precios de referencia, advertencias y limitaciones.",
    },
    {
      nombre: "Matriz de comparables",
      formatos: ["Excel"],
      descripcion: "Procesos similares, valores, objeto, entidad, observaciones.",
    },
    {
      nombre: "Matriz de riesgos",
      formatos: ["Excel", "Word"],
      descripcion: "Riesgo, causa, impacto, probabilidad, asignación, mitigación, garantías relacionadas.",
    },
    {
      nombre: "Ficha técnica / anexo técnico",
      formatos: ["Word"],
      descripcion: "Especificaciones, entregables, condiciones técnicas, cantidades si aplica.",
    },
    {
      nombre: "Matriz de requisitos habilitantes preliminares",
      formatos: ["Excel", "Word"],
      descripcion: "Capacidad jurídica, técnica, financiera, experiencia.",
    },
    {
      nombre: "Criterios de evaluación / selección",
      formatos: ["Word", "Excel"],
      descripcion: "Factores sugeridos, ponderación o reglas según modalidad.",
    },
    {
      nombre: "Borrador de invitación, pliego o condiciones del proceso",
      formatos: ["Word"],
      descripcion: "Según modalidad aplicable.",
    },
    {
      nombre: "Borrador de minuta contractual o clausulado base",
      formatos: ["Word"],
      descripcion: "Obligaciones, plazo, valor, forma de pago, garantías, supervisión, causales básicas.",
    },
    {
      nombre: "Cronograma preliminar",
      formatos: ["Excel", "Word"],
      descripcion: "Etapas, fechas sugeridas, responsables.",
    },
    {
      nombre: "Checklist SECOP / publicación / anexos",
      formatos: ["Excel"],
      descripcion: "Qué debe cargarse, revisarse o conseguirse antes de publicar.",
    },
    {
      nombre: "Resumen ejecutivo para decisión",
      formatos: ["PDF", "Pantalla"],
      descripcion: "Versión breve para cliente, socio, ordenador del gasto o equipo.",
    },
  ],
  kit_revisado: [
    {
      nombre: "Estudios previos / documento base de planeación",
      formatos: ["Word"],
      descripcion: "Necesidad, objeto, alcance, obligaciones, plazo, forma de pago, supervisión, modalidad, valor, riesgos y garantías.",
    },
    {
      nombre: "Justificación de modalidad de selección",
      formatos: ["Word"],
      descripcion: "Fundamento y explicación de la ruta recomendada.",
    },
    {
      nombre: "Análisis del sector / mercado básico",
      formatos: ["Word", "Excel"],
      descripcion: "Fuentes, comparables, precios de referencia, advertencias y limitaciones.",
    },
    {
      nombre: "Matriz de comparables",
      formatos: ["Excel"],
      descripcion: "Procesos similares, valores, objeto, entidad, observaciones.",
    },
    {
      nombre: "Matriz de riesgos",
      formatos: ["Excel", "Word"],
      descripcion: "Riesgo, causa, impacto, probabilidad, asignación, mitigación, garantías relacionadas.",
    },
    {
      nombre: "Ficha técnica / anexo técnico",
      formatos: ["Word"],
      descripcion: "Especificaciones, entregables, condiciones técnicas, cantidades si aplica.",
    },
    {
      nombre: "Matriz de requisitos habilitantes preliminares",
      formatos: ["Excel", "Word"],
      descripcion: "Capacidad jurídica, técnica, financiera, experiencia.",
    },
    {
      nombre: "Criterios de evaluación / selección",
      formatos: ["Word", "Excel"],
      descripcion: "Factores sugeridos, ponderación o reglas según modalidad.",
    },
    {
      nombre: "Borrador de invitación, pliego o condiciones del proceso",
      formatos: ["Word"],
      descripcion: "Según modalidad aplicable.",
    },
    {
      nombre: "Borrador de minuta contractual o clausulado base",
      formatos: ["Word"],
      descripcion: "Obligaciones, plazo, valor, forma de pago, garantías, supervisión, causales básicas.",
    },
    {
      nombre: "Cronograma preliminar",
      formatos: ["Excel", "Word"],
      descripcion: "Etapas, fechas sugeridas, responsables.",
    },
    {
      nombre: "Checklist SECOP / publicación / anexos",
      formatos: ["Excel"],
      descripcion: "Qué debe cargarse, revisarse o conseguirse antes de publicar.",
    },
    {
      nombre: "Resumen ejecutivo para decisión",
      formatos: ["PDF", "Pantalla"],
      descripcion: "Versión breve para cliente, socio, ordenador del gasto o equipo.",
    },
    {
      nombre: "Kit revisado por experto",
      formatos: ["Word", "PDF"],
      descripcion: "Documentos ajustados o comentados.",
    },
    {
      nombre: "Informe de revisión del Kit",
      formatos: ["PDF"],
      descripcion: "Hallazgos, riesgos críticos, recomendaciones y limitaciones.",
    },
    {
      nombre: "Control de cambios / comentarios",
      formatos: ["Word"],
      descripcion: "Observaciones directamente sobre los documentos.",
    },
    {
      nombre: "Checklist de revisión humana",
      formatos: ["PDF"],
      descripcion: "Evidencia de revisión por bloques.",
    },
    {
      nombre: "Versión final asistida",
      formatos: ["Word", "PDF"],
      descripcion: "Entregable más limpio para uso interno del cliente.",
    },
  ],
};

export default function EntregablesPanel({ nivel, testid }) {
  const items = ENTREGABLES_MAP[nivel] || [];
  
  if (items.length === 0) {
    return (
      <div className="text-sm text-gray-500 italic" data-testid={testid}>
        No hay entregables definidos para este nivel.
      </div>
    );
  }

  return (
    <div className="space-y-3" data-testid={testid}>
      {items.map((item, idx) => (
        <div
          key={`${nivel}-${idx}`}
          className="flex gap-3 border border-gray-200 bg-white p-4 rounded-sm"
          data-testid={`entregable-${idx}`}
        >
          <div className="flex-1">
            <h4 className="font-medium text-gray-900 text-sm mb-1">{item.nombre}</h4>
            <p className="text-xs text-gray-600 mb-2">{item.descripcion}</p>
            <div className="flex flex-wrap gap-1">
              {item.formatos.map((fmt) => (
                <Badge
                  key={fmt}
                  variant="outline"
                  className={`text-[10px] uppercase tracking-wider border ${FORMAT_STYLES[fmt] || "bg-gray-100 text-gray-700 border-gray-300"}`}
                >
                  {fmt}
                </Badge>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
